
import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { parseHttpErrorBody } from '../shared/forms/parse-http-error-body';
import {RequestParameters} from '../shared/models/request-parameters/parameter.model';
import {Observable} from 'rxjs/Observable';

import {GlobalVariable} from '../global';
import {CommissionAccount} from './commission-account.model';
import {Subject} from 'rxjs/Subject';


@Injectable()
export class CommissionAccountService {
  private subject = new Subject<any>();
  constructor(private http: HttpClient) {
  }


  getAccounts(parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/commission-accounts', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  disableAccount(account: CommissionAccount, stateToApply) {
    return this.http.put(GlobalVariable.BASE_API_URL + '/commission-account/' + account.reference + '/' + stateToApply, {})
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch((error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  getAccount (reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/commission-account/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

 
  emitMessage(msg: object) {
    this.subject.next(msg);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/commission-account/commission-account.service.ts